import { render } from "./NyuukaPage.vue?vue&type=template&id=f23b0d5a"
import script from "./NyuukaPage.vue?vue&type=script&lang=js"
export * from "./NyuukaPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\eguchi\\Desktop\\git\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__